/**
 * Reads the content of a <meta property="..."> tag.
 */
export function getMetadata(propertyName: string): string | undefined {
  const metaElement = document.querySelector(`meta[property='${propertyName}']`);
  return metaElement?.getAttribute('content') ?? undefined;
}
